/**
 * Checks if a string is a valid uuid
 * @param {string} potentialUUID
 * @returns {boolean}
 */
export const isUUID = (potentialUUID: string): boolean => {
  /* eslint-disable-next-line @typescript-eslint/prefer-regexp-exec */
  return potentialUUID.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i) !== null;
};
